import { CustomRadioInputContainer, CustomRadioInputContent } from './styles';

export interface ICustomRadioInputProps {
  isChecked: boolean;
  handleClick?: (value?: string) => void;
  value?: string;
  hasMargin?: boolean;
  disabled?: boolean;
}

const CustomRadioInput = ({
  isChecked,
  handleClick,
  value,
  hasMargin,
  disabled,
}: ICustomRadioInputProps) => {
  return (
    <CustomRadioInputContainer
      onClick={() => handleClick && handleClick(value)}
      style={{ margin: hasMargin ? '1rem' : 'none' }}
    >
      {isChecked && !disabled && <CustomRadioInputContent />}
    </CustomRadioInputContainer>
  );
};

export default CustomRadioInput;
